var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entity--sign mx-1"},[_c('span',{staticClass:"d-block m0 p-1 lh-10 fs-10 text-dark z-depth-1"},[_vm._t("content",null,{dataTest:""})],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2352f7df","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/StreetSign.vue
// module id = JA2G
// module chunks = 0